export default (address) => {
  if (!address.postalId) return false;
  return Object.keys(address).filter(field => field !== 'showLookupSelection')
    .some(field => address[field].toLowerCase().includes('packstation') && field !== 'postalId');
};
